import ko from 'rgs-knockout';

export default class MapOfObservables {
	constructor () {
		const map = new Map();

		this._default = ko.observable();
		this.get = k => {
			if (!k) {
				return this._default;
			}
			if (!map.has(k)) {
				map.set(k, ko.observable());
			}
			return map.get(k);
		};
	}
}